var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.readyToPlay)?_c('video-player',{attrs:{"src":_vm.playbackUrl,"options":_vm.videoOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }